export const colorBindingTypes = {
  MARGIN: 1,
  BUYING_POWER: 2,
  HOLD_AMOUNT: 4,
  UP_DOWN: 8
}

export const colorValue = {
  MARGIN: '#1996E3',
  BUYING_POWER: '#E64033',
  HOLD_AMOUNT: '#FFAD4D',
  UP: 'var(--price-rise-color)',
  DOWN: 'var(--price-fall-color)'
}